import { CampaignDetails } from '@/scopes/search/search/pages/SearchPage/components/Results/ProductCard/CampaignDetails';
import { BulletList, tk, Typography, type IconGlyph } from '@sunwebgroup/ui-components';
import * as React from 'react';
import { type SearchResult } from '@/scopes/search/search/infrastructure/api/types';
import { styled } from 'styled-components';

const HighLightedWord = styled.b`
  color: ${tk('color_semantic_bg_primary')};
`;

const Item = styled(BulletList.Item)`
  align-items: center;
`;

export const CampaignUsp = ({ campaign }: { campaign: SearchResult['campaign'] }) => {
  if (!campaign) return null;
  const { title, icon, highlightedWord } = campaign;
  const bulletIcon = icon ? (icon as IconGlyph) : 'IconTag';

  let campaignTitle = <Typography $variant="body-md">{title}</Typography>;
  if (highlightedWord && highlightedWord !== '' && title.includes(highlightedWord)) {
    const splitTitle = title.split(highlightedWord);
    campaignTitle = (
      <Typography $variant="body-md">
        {splitTitle[0]}
        <HighLightedWord>{highlightedWord}</HighLightedWord>
        {splitTitle[1]}
      </Typography>
    );
  }

  return (
    <Item $icon={bulletIcon} data-qa="product-campaign-usp">
      {campaignTitle}
      <CampaignDetails {...campaign} />
    </Item>
  );
};
